<template>
  <div class="operate">
    <div class="operate-btn" @click="handleCreateClick">
      <span>创建任务</span>
    </div>
    <select-task-group
      v-if="visible"
      v-model="visible"
      :item="item"
      :build="build"
      @createCanvas="handleCreateCanvas"
      @comfirm="handleConfirm"
    />
    <edit-group
      v-if="editVisible"
      v-model="editVisible"
      :tabList="tabList"
      :addable="false"
      @comfirm="handleEditComfirm"
    />
  </div>
</template>

<script>
import selectTaskGroup from "./selectTaskGroup.vue";
import editGroup from "./editGroup.vue";

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    build: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    selectTaskGroup,
    editGroup,
  },
  computed: {
    tabList() {
      if (this.packs && this.packs.length) {
        return this.packs.map((item) => {
          return {
            name: item.crowdName,
            crowdNo: item.crowdNo,
            editData: {
              id: item.crowdNo,
              name: item.crowdName,
              description: item.crowdDescription,
              classifyId: item.crowdCategory,
              strategy: JSON.stringify(item.payload.strategy),
            },
          };
        });
      } else {
        return [];
      }
    },
  },
  data() {
    return {
      visible: false,
      editVisible: false,
      packs: [],
    };
  },
  methods: {
    handleCreateClick() {
      this.visible = true;
    },
    handleConfirm(val) {
      this.$emit("comfirm", val);
      this.packs = val.packs;
      this.editVisible = true;
    },
    handleEditComfirm(val) {
      const packs = val.map((item) => {
        return {
          crowdNo: item.crowdNo,
          crowdName: item.name,
          crowdCategory: item.params.crowdCategory
            ? item.params.crowdCategory
            : null,
          crowdDescription: item.params.crowdDescription,
          payload: {
            strategy: item.params.strategy,
          },
        };
      });
      this.$emit("sure", packs);
      this.visible = true;
    },
    handleCreateCanvas() {
      this.$emit("createCanvas");
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.operate {
  padding-bottom: 10px;
  margin-top: 20px;
  &-btn {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid #3159ff;
    cursor: pointer;
    font-size: 12px;
    padding: 0px 12px;
    color: #3159ff;
    display: inline-block;
  }
  &-sure {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #3159ff;
    border-radius: 20px;
    cursor: pointer;
    font-size: 12px;
    padding: 0px 12px;
    color: #fff;
    display: inline-block;
  }
}
.margin-l8 {
  margin-left: 8px;
}
</style>